// Tipos de arquivo permitidos para documentos enviados pelo candidato (não editáveis)

export const CANDIDATE_DOC_ACCEPT = 'application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png';

export const CANDIDATE_DOC_PDF_ACCEPT = 'application/pdf,.pdf';

export const CANDIDATE_DOC_IMAGE_ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png';

export const CANDIDATE_DOC_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
];

/** Android costuma enviar PDF como octet-stream — aceitar se a extensão for .pdf */
export const CANDIDATE_DOC_FALLBACK_MIMES = [
  'application/octet-stream',
];

export const CANDIDATE_DOC_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];

export const CANDIDATE_DOC_MAX_BYTES = 5 * 1024 * 1024;

export const CANDIDATE_DOC_FORMATS_LABEL = 'PDF, JPG ou PNG';

function fileExtension(name) {
  const n = String(name || '').toLowerCase();
  const dot = n.lastIndexOf('.');
  return dot >= 0 ? n.slice(dot) : '';
}

export function isAllowedCandidateDocumentFile(file) {
  if (!file) return false;
  const ext = fileExtension(file.name);
  const extOk = CANDIDATE_DOC_EXTENSIONS.includes(ext);
  if (!extOk) return false;
  if (file.size > CANDIDATE_DOC_MAX_BYTES) return false;
  const mime = String(file.type || '').toLowerCase().split(';')[0].trim();
  if (!mime) return true;
  if (CANDIDATE_DOC_MIME_TYPES.includes(mime)) return true;
  if (CANDIDATE_DOC_FALLBACK_MIMES.includes(mime) && ext === '.pdf') return true;
  return false;
}

export function candidateDocumentRejectReason(file) {
  if (!file) return 'Nenhum arquivo selecionado';
  if (file.size > CANDIDATE_DOC_MAX_BYTES) return 'Arquivo muito grande. Tamanho máximo: 5MB';
  if (!isAllowedCandidateDocumentFile(file)) {
    return `Tipo de arquivo não suportado. Use apenas ${CANDIDATE_DOC_FORMATS_LABEL}.`;
  }
  return null;
}

/** Lê o arquivo na hora (Samsung/PWA perde acesso ao PDF do «Arquivos» se adiar). */
export async function prepareCandidateUploadFile(file) {
  if (!file) throw new Error('Nenhum arquivo selecionado');
  const name = file.name || 'documento';
  const ext = fileExtension(name);
  let buffer;
  try {
    buffer = await file.arrayBuffer();
  } catch {
    throw new Error(
      'Não foi possível ler o arquivo neste aparelho. Feche o app, abra de novo pelo ícone na tela inicial e tente outra vez — ou envie uma foto nítida do documento.',
    );
  }
  if (!buffer.byteLength) {
    throw new Error('Arquivo vazio ou inacessível. Escolha o documento de novo ou envie uma foto.');
  }
  if (buffer.byteLength > CANDIDATE_DOC_MAX_BYTES) {
    throw new Error('Arquivo muito grande. Tamanho máximo: 5MB');
  }
  let type = String(file.type || '').toLowerCase().split(';')[0].trim();
  if (ext === '.pdf') type = 'application/pdf';
  else if (ext === '.jpg' || ext === '.jpeg') type = 'image/jpeg';
  else if (ext === '.png') type = 'image/png';
  return new File([buffer], name, { type, lastModified: file.lastModified || Date.now() });
}
